import _ from 'lodash';
import React from 'react';
import PrimaryImageContext from './context';
import { useRemovePrimaryImage } from '../../../../../services/wire/primary-image-services';

export default function Viewer() {
  const { state: { mediaUrl, wireId }, dispatch } = React.useContext(PrimaryImageContext);
  const [{ response }, remove] = useRemovePrimaryImage(wireId);

  React.useEffect(() => {
    if (_.get(response, 'status') === 204) {
      dispatch({ type: 'setUrl', payload: null });
    }
  }, [response, dispatch]);

  return (
    <>
      <img className="sidebar-item-image primary-image" src={mediaUrl} alt="Primary" />
      <a
        href="#"
        className="sidebar-item-link remove"
        onClick={e => e.preventDefault() || remove()}
      >
        remove
      </a>
    </>
  );
}
